<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">Gestión de {{'Proveedor' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <!-- Datos de proveedor -->
      <div fxLayout="row stretch" fxLayout.xs="column">

        <mat-expansion-panel [expanded]="true" fxFlex=100 fxFlex.xs=100>

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos de {{'Proveedor' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <ng-container *ngIf="canAdd || canEdit">

            <form [formGroup]="formGroup">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">Código*</mat-label>
                    <input class="text-style" matInput formControlName="Codigo" maxlength="100" (keyup.enter)="onGuardar()">
                    <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                      {{ getErrorCodigo() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">Razón Social*</mat-label>
                    <input class="text-style" matInput formControlName="RazonSocial" maxlength="150" (keyup.enter)="onGuardar()">
                    <mat-error *ngIf="!formGroup.controls['RazonSocial'].valid && formGroup.controls['RazonSocial'].touched">
                      {{ getErrorRazonSocial() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">CUIT*</mat-label>
                    <input type="number" class="text-style" matInput formControlName="Cuit" (keyup.enter)="onGuardar()">
                    <mat-error *ngIf="!formGroup.controls['Cuit'].valid && formGroup.controls['Cuit'].touched">
                      {{ getErrorCuit() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isActividadSearching">Actividad Principal</mat-label>
                    <mat-label *ngIf="isActividadSearching">Cargando...</mat-label>
                    <mat-select formControlName="ActividadPrincipalId">
                      <mat-option>Ninguno</mat-option>
                      <mat-option *ngFor="let s of actividadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!formGroup.controls['ActividadPrincipalId'].valid && formGroup.controls['ActividadPrincipalId'].touched">
                      {{ getErrorPais() }}
                    </mat-error>
                  </mat-form-field>
                </div>

              </div>

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isPaisSearching">País</mat-label>
                    <mat-label *ngIf="isPaisSearching">Cargando...</mat-label>
                    <mat-select formControlName="PaisId">
                      <mat-option *ngFor="let s of paisesList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!formGroup.controls['PaisId'].valid && formGroup.controls['PaisId'].touched">
                      {{ getErrorPais() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">Domicilio</mat-label>
                    <input class="text-style" matInput formControlName="Domicilio" maxlength="150" (keyup.enter)="onGuardar()">
                    <mat-error *ngIf="!formGroup.controls['Domicilio'].valid && formGroup.controls['Domicilio'].touched">
                      {{ getErrorDomicilio() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">Localidad</mat-label>
                    <input class="text-style" matInput formControlName="LocalidadBarrio" maxlength="100" (keyup.enter)="onGuardar()">
                    <mat-error
                      *ngIf="!formGroup.controls['LocalidadBarrio'].valid && formGroup.controls['LocalidadBarrio'].touched">
                      {{ getErrorLocalidadBarrio() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">Código Postal</mat-label>
                    <input class="text-style" matInput formControlName="CodigoPostal" maxlength="50" (keyup.enter)="onGuardar()">
                    <mat-error
                      *ngIf="!formGroup.controls['CodigoPostal'].valid && formGroup.controls['CodigoPostal'].touched">
                      {{ getErrorCodigoPostal() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">Observaciones</mat-label>
                    <input class="text-style" matInput formControlName="Observacion" (keyup.enter)="onGuardar()">
                    <mat-error
                      *ngIf="!formGroup.controls['Observacion'].valid && formGroup.controls['Observacion'].touched">
                      {{ getErrorObservacion() }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

            </form>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
                <mat-checkbox [(ngModel)]="item.Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox>
              </div>
            </div>

          </ng-container>

          <ng-container *ngIf="!canAdd && !canEdit">

            <div fxLayout="row stretch" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Código</b>: {{item.Codigo}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Razón Social</b>: {{item.RazonSocial}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>CUIT</b>: {{item.Cuit}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Domicilio</b>: {{item.Domicilio}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Localidad/Barrio</b>: {{item.LocalidadBarrio}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Código Postal</b>: {{item.CodigoPostal}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>País</b>: {{item.PaisNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Observaciones</b>: {{item.Observacion}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>
          </ng-container>

        </mat-expansion-panel>

      </div>

      <br/>
      
      <!-- Datos de Contacto -->
      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="canAdd || canEdit">

        <mat-expansion-panel [expanded]="true" fxFlex=49 style="gap:5 px" fxFlex.xs=100>

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Contacto
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="contacto1FormGroup">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
                <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #add5ff;">
                  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                    <mat-label>
                      ¿Ya tenes cargados los datos de la persona para asociarlos como contacto?
                    </mat-label>
                  </div>
                  <br/>
                  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                    <button mat-raised-button (click)="onContacto1SearchClick()" [disabled]="isProcessing()" color="accent" class="zb-button">Buscar Datos de Persona Existente</button>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

            <hr style="margin:20px 0px; width: 100%;">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label>
                      <b># Persona</b>: 
                      <ng-container *ngIf="item?.PersonaContactoId > 0">
                        <a style="cursor: pointer; margin-right: 5px" (click)="viewPersona(item?.PersonaContactoId)">{{item?.PersonaContactoId}}</a>
                      </ng-container>
                      <ng-container *ngIf="!(item?.PersonaContactoId > 0)">NUEVO</ng-container>
                    </mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" style="margin-top: 5px;">
                <button mat-raised-button (click)="onContacto1DeassociateClick()" [disabled]="isProcessing()" *ngIf="canDeassociateContacto1()" color="warn" class="zb-button">
                  Cargar como Nueva Persona
                </button>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre*</mat-label>
                  <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!contacto1FormGroup.controls['Nombre'].valid && contacto1FormGroup.controls['Nombre'].touched">
                    {{ getErrorNombre1() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Apellido*</mat-label>
                  <input matInput formControlName="Apellido" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!contacto1FormGroup.controls['Apellido'].valid && contacto1FormGroup.controls['Apellido'].touched">
                    {{ getErrorApellido1() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoDocumentoSearching">Tipo Documento</mat-label>
                  <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoDocumentoId" (selectionChange)="onTipoDocumentoSelection()">
                    <mat-option>Ninguno</mat-option>
                    <mat-option *ngFor="let s of tipoDocumentoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!contacto1FormGroup.controls['TipoDocumentoId'].valid && contacto1FormGroup.controls['TipoDocumentoId'].touched">
                    {{ getErrorTipoDocumentoId1() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nro. Documento</mat-label>
                  <input matInput formControlName="NroDocumento" maxlength="100" (change)="onNroDocumentoChange()"
                    (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!contacto1FormGroup.controls['NroDocumento'].valid && contacto1FormGroup.controls['NroDocumento'].touched">
                    {{ getErrorNroDocumento1() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="showCuit">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>CUIT/CUIL</mat-label>
                  <input matInput formControlName="Cuit" type="number" (change)="onCuitChange()" (keyup.enter)="onGuardarUsuario()">
                  <mat-error *ngIf="!contacto1FormGroup.controls['Cuit'].valid && contacto1FormGroup.controls['Cuit'].touched">
                    {{ getErrorCuit1() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Mail de Contacto</mat-label>
                  <input matInput formControlName="MailContacto" (keyup.enter)="onGuardar()" maxlength="255">
                  <mat-error *ngIf="!contacto1FormGroup.controls['MailContacto'].valid && contacto1FormGroup.controls['MailContacto'].touched">
                    {{ getErroMailContacto1() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Móvil de Contacto</mat-label>
                  <input matInput formControlName="MovilContacto" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error
                    *ngIf="!contacto1FormGroup.controls['MovilContacto'].valid && contacto1FormGroup.controls['MovilContacto'].touched">
                    {{ getErrorMovilContacto1() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Móvil de Contacto Otro</mat-label>
                  <input matInput formControlName="MovilContactoOtro" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error
                    *ngIf="!contacto1FormGroup.controls['MovilContactoOtro'].valid && contacto1FormGroup.controls['MovilContactoOtro'].touched">
                    {{ getErroMovilContactoOtro1() }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

          </form>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" fxFlex=49 style="gap:5 px" fxFlexOffset=2 fxFlex.xs=100 fxFlexOffset.xs=0>

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Contacto Opcional
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="contacto2FormGroup">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" width="100%">
                <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #add5ff;">
                  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                    <mat-label>
                      ¿Ya tenes cargados los datos de la persona para asociarlos como contacto opcional?
                    </mat-label>
                  </div>
                  <br/>
                  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                    <button mat-raised-button (click)="onContacto2SearchClick()" [disabled]="isProcessing()" color="accent" class="zb-button">Buscar Datos de Persona Existente</button>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

            <hr style="margin:20px 0px; width: 100%;">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label>
                      <b># Persona</b>: 
                      <ng-container *ngIf="item?.PersonaContactoOpcionalId > 0">
                        <a style="cursor: pointer; margin-right: 5px" (click)="viewPersona(item?.PersonaContactoOpcionalId)">{{item?.PersonaContactoOpcionalId}}</a>
                      </ng-container>
                      <ng-container *ngIf="!(item?.PersonaContactoOpcionalId > 0)">NUEVO</ng-container>
                    </mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center center" class="flex-item" style="margin-top: 5px;">
                <button mat-raised-button (click)="onContacto2DeassociateClick()" [disabled]="isProcessing()" *ngIf="canDeassociateContacto2()" color="warn" class="zb-button">
                  Cargar como Nueva Persona
                </button>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre*</mat-label>
                  <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!contacto2FormGroup.controls['Nombre'].valid && contacto2FormGroup.controls['Nombre'].touched">
                    {{ getErrorNombre2() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Apellido*</mat-label>
                  <input matInput formControlName="Apellido" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!contacto2FormGroup.controls['Apellido'].valid && contacto2FormGroup.controls['Apellido'].touched">
                    {{ getErrorApellido2() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoDocumentoSearching">Tipo Documento</mat-label>
                  <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoDocumentoId" (selectionChange)="onTipoDocumentoSelection()">
                    <mat-option>Ninguno</mat-option>
                    <mat-option *ngFor="let s of tipoDocumentoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!contacto2FormGroup.controls['TipoDocumentoId'].valid && contacto2FormGroup.controls['TipoDocumentoId'].touched">
                    {{ getErrorTipoDocumentoId2() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nro. Documento</mat-label>
                  <input matInput formControlName="NroDocumento" maxlength="100" (change)="onNroDocumentoChange()"
                    (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!contacto2FormGroup.controls['NroDocumento'].valid && contacto2FormGroup.controls['NroDocumento'].touched">
                    {{ getErrorNroDocumento2() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="showCuit">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>CUIT/CUIL</mat-label>
                  <input matInput formControlName="Cuit" type="number" (change)="onCuitChange()" (keyup.enter)="onGuardarUsuario()">
                  <mat-error *ngIf="!contacto2FormGroup.controls['Cuit'].valid && contacto2FormGroup.controls['Cuit'].touched">
                    {{ getErrorCuit2() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Mail de Contacto</mat-label>
                  <input matInput formControlName="MailContacto" (keyup.enter)="onGuardar()" maxlength="255">
                  <mat-error *ngIf="!contacto2FormGroup.controls['MailContacto'].valid && contacto2FormGroup.controls['MailContacto'].touched">
                    {{ getErroMailContacto2() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Móvil de Contacto</mat-label>
                  <input matInput formControlName="MovilContacto" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error
                    *ngIf="!contacto2FormGroup.controls['MovilContacto'].valid && contacto2FormGroup.controls['MovilContacto'].touched">
                    {{ getErrorMovilContacto2() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Móvil de Contacto Otro</mat-label>
                  <input matInput formControlName="MovilContactoOtro" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error
                    *ngIf="!contacto2FormGroup.controls['MovilContactoOtro'].valid && contacto2FormGroup.controls['MovilContactoOtro'].touched">
                    {{ getErroMovilContactoOtro2() }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

          </form>

        </mat-expansion-panel>

      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!canAdd && !canEdit">

        <mat-expansion-panel [expanded]="true" fxFlex=47 fxFlex.xs=100>

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Contacto
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="item?.PersonaContactoId != null && item?.PersonaContactoId > 0">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre</b>: {{item?.PersonaContacto?.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Apellido</b>: {{item?.PersonaContacto?.Apellido}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Doc.</b>: {{item?.PersonaContacto?.TipoDocumentoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nro. Doc.</b>: {{item?.PersonaContacto?.NroDocumento}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Mail de Contacto</b>: {{item?.PersonaContacto?.MailContacto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Móvil de Contacto</b>: {{item?.PersonaContacto?.MovilContacto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Móvil Contacto Otro</b>: {{item?.PersonaContacto?.MovilContactoOtro}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="!(item?.PersonaContactoId != null && item?.PersonaContactoId > 0)" style="text-align: center; font-weight: bold;">
            <mat-label>No hay un contacto asociado.</mat-label>
          </div>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" fxFlex=47 fxFlexOffset=2 fxFlex.xs=100 fxFlexOffset.xs=0>

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Contacto Opcional
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="item?.PersonaContactoOpcionalId != null && item?.PersonaContactoOpcionalId > 0">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre</b>: {{item?.PersonaContactoOpcional?.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Apellido</b>: {{item?.PersonaContactoOpcional?.Apellido}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Doc.</b>: {{item?.PersonaContactoOpcional?.TipoDocumentoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nro. Doc.</b>: {{item?.PersonaContactoOpcional?.NroDocumento}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Mail de Contacto</b>: {{item?.PersonaContactoOpcional?.MailContacto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Móvil de Contacto</b>: {{item?.PersonaContactoOpcional?.MovilContacto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Móvil Contacto Otro</b>: {{item?.PersonaContactoOpcional?.MovilContactoOtro}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="!(item?.PersonaContactoOpcionalId != null && item?.PersonaContactoOpcionalId > 0)" style="text-align: center; font-weight: bold;">
            <mat-label>No hay un contacto opcional asociado.</mat-label>
          </div>

        </mat-expansion-panel>

      </div>

      <br/>
      
      <!-- Cuentas de proveedor  -->
      <mat-expansion-panel [expanded]="true" *ngIf="canViewCuenta && item?.Id > 0">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-right: 5px;">account_balance_wallet</mat-icon> Cuentas
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
          
        </mat-expansion-panel-header>

        <form [formGroup]="cuentaBancariaFormGroup" *ngIf="canAddCuenta || canEditCuenta">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>CBU/CVU*</mat-label>
                <input matInput formControlName="ClaveBancaria"  maxlength="100">
                <mat-error
                  *ngIf="!cuentaBancariaFormGroup.controls['ClaveBancaria'].valid && cuentaBancariaFormGroup.controls['ClaveBancaria'].touched">
                  {{ getErrorClaveBancaria() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Alias*</mat-label>
                <input matInput formControlName="Alias" maxlength="100">
                <mat-error
                  *ngIf="!cuentaBancariaFormGroup.controls['Alias'].valid && cuentaBancariaFormGroup.controls['Alias'].touched">
                  {{ getErrorAlias() }}
                </mat-error>
              </mat-form-field>
            </div>
            
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isBancoSerching">Banco</mat-label>
                <mat-label *ngIf="isBancoSerching">Cargando...</mat-label>
                <mat-select formControlName="BancoId">
                  <mat-option *ngFor="let s of bancoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!cuentaBancariaFormGroup.controls['BancoId'].valid && cuentaBancariaFormGroup.controls['BancoId'].touched">
                  {{ getErrorBanco() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. de Cuenta</mat-label>
                <input matInput formControlName="NumeroCuenta" maxlength="100">
                <mat-error
                  *ngIf="!cuentaBancariaFormGroup.controls['NumeroCuenta'].valid && cuentaBancariaFormGroup.controls['NumeroCuenta'].touched">
                  {{ getErrorNumeroCuenta() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-label">Titular</mat-label>
                <input matInput formControlName="Titular" maxlength="100">
                <mat-error *ngIf="!cuentaBancariaFormGroup.controls['Titular'].valid && cuentaBancariaFormGroup.controls['Titular'].touched">
                  {{ getErrorTitular() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
                <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                <mat-select formControlName="MonedaId">
                  <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!cuentaBancariaFormGroup.controls['MonedaId'].valid && cuentaBancariaFormGroup.controls['MonedaId'].touched">
                  {{ getErrorMoneda() }}
                </mat-error>
              </mat-form-field>
            </div>
           
            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px 0;" align="end">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <button mat-raised-button (click)="onCuentaSave()" [disabled]="isProcessing()" color="primary"
                  class="zb-button">Guardar Cuenta</button>
              </div>
            </div>

          </div>

        </form>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <ejs-grid #cuentasGrid [dataSource]='item.Cuentas' [allowPaging]="true" [allowSorting]="true"
            [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
            [allowResizing]='true'>
            <e-columns>
              <e-column field='BancoNombre' headerText='Banco' width=100></e-column>
              <e-column field='NumeroCuenta' headerText='Nro. Cuenta' width=100></e-column>
              <e-column field='ClaveBancaria' headerText='CBU/CVU' width=100></e-column>
              <e-column field='Alias' headerText='Alias' width=150></e-column>
              <e-column field='MonedaCodigo' headerText='Moneda' width=100></e-column>
              <e-column headerText='Acciones' width=90 *ngIf="canEditCuenta || canDeleteCuenta">
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="onCuentaView(data)" *ngIf="canEditCuenta"
                    title="Ver cuenta"><i class="fa fa-eye fa-1x"></i>
                  </a>
                  <a style="cursor: pointer; margin-right: 5px" (click)="onCuentaDelete(data)" *ngIf="canDeleteCuenta"
                    title="Eliminar cuenta"><i class="fa fa-trash fa-1x"></i>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>

      </mat-expansion-panel>

      <!-- Reporte productividad -->
      <ng-container *ngIf="item.Id > 0">

        <br/>
        
        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">bar_chart</mat-icon> Productividad del Proveedor
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-label *ngIf="isReporteProductividadSearching">Buscando...</mat-label>
              
              <ng-container *ngIf="!isReporteProductividadSearching">

                <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlPedidos">

                  <div fxLayout="row stretch" class="zb-readonly">

                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Pedidos Entregados</b>:<br/>{{proveedorProductividad?.TotalPedidosEntregados}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Cant. Entregados Parcial</b>:<br/>{{proveedorProductividad?.CantidadPedidosEntregadosParcial}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Cant. Entregados En Fecha</b>:<br/>{{proveedorProductividad?.CantidadPedidosEntregadosEnFecha}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Plazo Prom. Entrega</b>:<br/>{{proveedorProductividad?.PedidosPlazoEntregaPromedio | number:'1.2-2'}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                  </div>

                  <div fxLayout="row stretch" class="zb-readonly" *ngIf="proveedorProductividad?.TotalPedidosEntregados != null && proveedorProductividad?.TotalPedidosEntregados > 0">
                    <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Monto Promedio en Pedidos Entregados</b></mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngFor="let ii of proveedorProductividad?.PedidosEntregadosMontoPromedio | keyvalue">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>{{ii.key}}:</b> {{ii.value | number: '1.2-2'}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>

                  <div fxLayout="row stretch" class="zb-readonly">

                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Presupuestos Realizados</b>:<br/>{{proveedorProductividad?.TotalPresupuestosRealizados}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Cant. Seleccionados</b>:<br/>{{proveedorProductividad?.CantidadPresupuestosSeleccionados}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Cant. con Flete Incluido</b>:<br/>{{proveedorProductividad?.CantidadPresupuestosIncluyeFlete}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                  </div>

                  <div fxLayout="row stretch" class="zb-readonly" *ngIf="proveedorProductividad?.TotalPresupuestosRealizados != null && proveedorProductividad?.TotalPresupuestosRealizados > 0">
                    <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Monto Promedio en Presupuestos Realizados</b></mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngFor="let ii of proveedorProductividad?.PresupuestoMontoPromedio | keyvalue">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>{{ii.key}}:</b> {{ii.value | number: '1.2-2'}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>

                </ng-container>

                <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlGastos">

                  <div fxLayout="row stretch" class="zb-readonly">

                    <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Gastos Asignados</b>:<br/>{{proveedorProductividad?.TotalGastosAsignados}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                  </div>

                  <div fxLayout="row stretch" class="zb-readonly" *ngIf="proveedorProductividad?.TotalGastosAsignados != null && proveedorProductividad?.TotalGastosAsignados > 0">
                    <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>Monto Promedio en Gastos</b></mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngFor="let ii of proveedorProductividad?.GastoMontoPromedio | keyvalue">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-style"><b>{{ii.key}}:</b> {{ii.value | number: '1.2-2'}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>

                </ng-container>

              </ng-container>

            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

      <!-- Incidencias -->
      <ng-container *ngIf="item.Id > 0 && canViewIncidencias">

        <br/>
        
        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">error</mat-icon> Incidencias Asociadas
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-label *ngIf="isIncidenciasSearching">Buscando...</mat-label>
              <ejs-grid #gridIncidencias [dataSource]='incidenciasList' [allowPaging]="true"
                [allowSorting]="true" *ngIf="!isIncidenciasSearching" [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='Id' headerText='#' width=60></e-column>
                  <e-column field='FechaUltimoMensaje' headerText='Fecha Ult. Actualización' type="Date" format="dd/MM/yyyy HH:mm" width=60></e-column>
                  <e-column field='IncidenciaUsuarioCategoriaNombre' headerText='Categoría' width=90></e-column>
                  <e-column field='ComunidadNombre' headerText='Comunidad' width=90>
                    <ng-template #headerTemplate let-data>
                      <div>
                        {{ 'Comunidad' | translate }}
                      </div>
                    </ng-template>
                  </e-column>
                  <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
                  <e-column field='Asunto' headerText='Asunto' width=120></e-column>
                  <e-column headerText='Acciones' width=40>
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 18px" (click)="viewIncidencia(data.Id)">
                        <mat-icon style="width: 5px; font-size: 18px;" title="Ver incidencia">visibility</mat-icon>
                      </a>
                    </ng-template>
                  </e-column>
                  
                </e-columns>
              </ejs-grid>

            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

      <!-- Gastos asociados -->
      <ng-container *ngIf="item.Id > 0 && canViewGastos">

        <br/>
        
        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">receipt</mat-icon> Gastos Asociados
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-label *ngIf="isGastosSearching">Buscando...</mat-label>
              <ejs-grid #grid [dataSource]='gastosList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='FechaGasto' headerText='Fecha' width=90>
                    <ng-template #template let-data>
                      {{data.FechaGasto | date:'dd/MM/yyyy'}}
                    </ng-template>
                  </e-column>
                  <e-column field='Comunidad' headerText='Comunidad' width=90>
                    <ng-template #headerTemplate let-data>
                      {{'Comunidad' | translate}}
                    </ng-template>
                  </e-column>
                  <e-column field='UfCodigo' headerText='Cód. UF' width=90></e-column>
                  <e-column field='TipoGasto' headerText='Tipo Gasto' width=90></e-column>
                  <e-column field='ServicioGasto' headerText='Servicio' width=90></e-column>
                  <e-column field='Detalle' headerText='Detalle' width=90></e-column>
                  <e-column field='Moneda' headerText='Moneda' width=90></e-column>
                  <e-column field='Importe' headerText='Importe' width=90>
                    <ng-template #template let-data>
                      {{data.Importe | number: '1.2-2'}}
                    </ng-template>
                  </e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canViewGastos">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="editGasto(data)"><i class="fa fa-eye fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

      <ng-container *ngIf="item.Id > 0 && canViewSaldos">

        <br/>
        
        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">monetization_on</mat-icon> Resumen de Saldos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;" *ngIf="isSaldosSearching">
            <mat-label>Buscando...</mat-label>
          </div>

          <ng-container *ngIf="!isSaldosSearching">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="saldosList == null || saldosList.length == 0" >
              <mat-label>No hay saldos para mostrar.</mat-label>
            </div>

            <ng-container *ngIf="saldosList != null && saldosList.length > 0">

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin-top: 10px;" *ngFor="let saldo of saldosList" >

                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label>
                        <b>Saldo Total</b>:
                        <span style="margin-left: 5px;" [ngStyle]="{ color: (saldo.SaldoTotal < 0) ? 'indianred' : 'black' }">{{saldo.Moneda}} {{saldo.SaldoTotal | number: '1.2-2'}}</span>
                      </mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo A Favor</b>: {{saldo.Moneda}} {{saldo.SaldoAFavor | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo Deudor</b>: {{saldo.Moneda}} {{saldo.SaldoDeudor | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo Vencido</b>: {{saldo.Moneda}} {{saldo.SaldoVencido | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </div>

            </ng-container>

          </ng-container>

        </mat-expansion-panel>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 10vh;">
    <div class="flex-actions">
      <button color="primary" mat-raised-button (click)="onGuardar()" *ngIf="canAdd || canEdit"
        [disabled]="isProcessing()">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button color="warn" mat-raised-button (click)="onCancel()">{{canAdd || canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isSaving" color="warn" class="zb-button">
        {{ isDeleting ? 'Eliminando...' : 'Eliminar'  }}
      </button>
    </div>
  </mat-card-actions> 

</mat-card>